import { render, staticRenderFns } from "./ABreadcrumbs.vue?vue&type=template&id=b4f026b6&scoped=true&"
import script from "./ABreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ABreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ABreadcrumbs.vue?vue&type=style&index=0&id=b4f026b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f026b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
